import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/dockets';

const namespace = 'APPEALS/DOCKETS';

export const SEARCH_DOCKETS = createRequestTypes(`${namespace}/SEARCH_DOCKETS`);

export const searchDockets = makeApiActionCreatorV3(
  api.searchDockets,
  SEARCH_DOCKETS[START],
  SEARCH_DOCKETS[SUCCESS],
  SEARCH_DOCKETS[ERROR],
);

export const COPY_DOCKETS = createRequestTypes(`${namespace}/COPY_DOCKETS`);

export const copyDocketToDateRange = makeApiActionCreatorV3(
  api.copyDocketToDateRange,
  COPY_DOCKETS[START],
  COPY_DOCKETS[SUCCESS],
  COPY_DOCKETS[ERROR],
);

export const INCREASE_DOCKET_CAPACITY = createRequestTypes(
  `${namespace}/INCREASE_DOCKET_CAPACITY`,
);

export const increaseDocketCapacity = makeApiActionCreatorV3(
  api.increaseDocketCapacity,
  INCREASE_DOCKET_CAPACITY[START],
  INCREASE_DOCKET_CAPACITY[SUCCESS],
  INCREASE_DOCKET_CAPACITY[ERROR],
);

export const CHANGE_DOCKET_CAPACITY = createRequestTypes(
  `${namespace}/CHANGE_DOCKET_CAPACITY`,
);

export const changeDocketCapacity = makeApiActionCreatorV3(
  api.changeDocketCapacity,
  CHANGE_DOCKET_CAPACITY[START],
  CHANGE_DOCKET_CAPACITY[SUCCESS],
  CHANGE_DOCKET_CAPACITY[ERROR],
);

export const MASS_CLOSE_DOCKET = createRequestTypes(
  `${namespace}/MASS_CLOSE_DOCKET`,
);

export const massCloseDocket = makeApiActionCreatorV3(
  api.massCloseDocket,
  MASS_CLOSE_DOCKET[START],
  MASS_CLOSE_DOCKET[SUCCESS],
  MASS_CLOSE_DOCKET[ERROR],
);

export const CLOSE_DOCKET = createRequestTypes(`${namespace}/CLOSE_DOCKET`);

export const closeDocket = makeApiActionCreatorV3(
  api.closeDocket,
  CLOSE_DOCKET[START],
  CLOSE_DOCKET[SUCCESS],
  CLOSE_DOCKET[ERROR],
);

export const DELETE_DOCKET = createRequestTypes(`${namespace}/DELETE_DOCKET`);

export const deleteDocket = makeApiActionCreatorV3(
  api.deleteDocket,
  DELETE_DOCKET[START],
  DELETE_DOCKET[SUCCESS],
  DELETE_DOCKET[ERROR],
);

export const FETCH_APPEAL_LOCATIONS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_LOCATIONS`,
);

export const fetchAppealLocations = makeApiActionCreatorV3(
  api.fetchAppealLocations,
  FETCH_APPEAL_LOCATIONS[START],
  FETCH_APPEAL_LOCATIONS[SUCCESS],
  FETCH_APPEAL_LOCATIONS[ERROR],
);

export const FETCH_APPEAL_LOCATION = createRequestTypes(
  `${namespace}/FETCH_APPEAL_LOCATION`,
);

export const fetchAppealLocation = makeApiActionCreatorV3(
  api.fetchAppealLocation,
  FETCH_APPEAL_LOCATION[START],
  FETCH_APPEAL_LOCATION[SUCCESS],
  FETCH_APPEAL_LOCATION[ERROR],
);

export const INSERT_APPEAL_LOCATION = createRequestTypes(
  `${namespace}/INSERT_APPEAL_LOCATION`,
);

export const insertAppealLocation = makeApiActionCreatorV3(
  api.insertAppealLocation,
  INSERT_APPEAL_LOCATION[START],
  INSERT_APPEAL_LOCATION[SUCCESS],
  INSERT_APPEAL_LOCATION[ERROR],
);

export const UPDATE_APPEAL_LOCATION = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_LOCATION`,
);

export const updateAppealLocation = makeApiActionCreatorV3(
  api.updateAppealLocation,
  UPDATE_APPEAL_LOCATION[START],
  UPDATE_APPEAL_LOCATION[SUCCESS],
  UPDATE_APPEAL_LOCATION[ERROR],
);

export const DELETE_APPEAL_LOCATION = createRequestTypes(
  `${namespace}/DELETE_APPEAL_LOCATION`,
);

export const deleteAppealLocation = makeApiActionCreatorV3(
  api.deleteAppealLocation,
  DELETE_APPEAL_LOCATION[START],
  DELETE_APPEAL_LOCATION[SUCCESS],
  DELETE_APPEAL_LOCATION[ERROR],
);

export const CREATE_APPEAL_DOCKET = createRequestTypes(
  `${namespace}/CREATE_APPEAL_DOCKET`,
);

export const createAppealDocket = makeApiActionCreatorV3(
  api.createAppealDocket,
  CREATE_APPEAL_DOCKET[START],
  CREATE_APPEAL_DOCKET[SUCCESS],
  CREATE_APPEAL_DOCKET[ERROR],
);

export const UPDATE_APPEAL_DOCKET = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_DOCKET`,
);

export const updateAppealDocket = makeApiActionCreatorV3(
  api.updateAppealDocket,
  UPDATE_APPEAL_DOCKET[START],
  UPDATE_APPEAL_DOCKET[SUCCESS],
  UPDATE_APPEAL_DOCKET[ERROR],
);

export const FETCH_DOCKET_TIME_SLOTS = createRequestTypes(
  `${namespace}/FETCH_DOCKET_TIME_SLOTS`,
);

export const fetchAllDocketTimeSlots = makeApiActionCreatorV3(
  api.fetchAllDocketTimeSlots,
  FETCH_DOCKET_TIME_SLOTS[START],
  FETCH_DOCKET_TIME_SLOTS[SUCCESS],
  FETCH_DOCKET_TIME_SLOTS[ERROR],
);

export const CREATE_DOCKET_TIME_SLOT = createRequestTypes(
  `${namespace}/CREATE_DOCKET_TIME_SLOT`,
);

export const createDocketTimeSlot = makeApiActionCreatorV3(
  api.createDocketTimeSlot,
  CREATE_DOCKET_TIME_SLOT[START],
  CREATE_DOCKET_TIME_SLOT[SUCCESS],
  CREATE_DOCKET_TIME_SLOT[ERROR],
);

export const RESET_DOCKET_TIME_SLOT = `${namespace}/RESET_DOCKET_TIME_SLOT`;

export const resetDocketTimeSlot = () => ({
  type: `${namespace}/RESET_DOCKET_TIME_SLOT`,
});

export const CLEAR_DOCKET_TIME_SLOT = createRequestTypes(
  `${namespace}/CLEAR_DOCKET_TIME_SLOT`,
);

export const clearDocketTimeSlot = makeApiActionCreatorV3(
  api.clearDocketTimeSlot,
  CLEAR_DOCKET_TIME_SLOT[START],
  CLEAR_DOCKET_TIME_SLOT[SUCCESS],
  CLEAR_DOCKET_TIME_SLOT[ERROR],
);

export const FINALIZE_DOCKET = createRequestTypes(
  `${namespace}/FINALIZE_DOCKET`,
);

export const finalizeDocket = makeApiActionCreatorV3(
  api.finalizeDocket,
  FINALIZE_DOCKET[START],
  FINALIZE_DOCKET[SUCCESS],
  FINALIZE_DOCKET[ERROR],
);

export const REOPEN_DOCKET = createRequestTypes(`${namespace}/REOPEN_DOCKET`);

export const reopenDocket = makeApiActionCreatorV3(
  api.reopenDocket,
  REOPEN_DOCKET[START],
  REOPEN_DOCKET[SUCCESS],
  REOPEN_DOCKET[ERROR],
);

export const DELETE_DOCKET_TIME_SLOT = createRequestTypes(
  `${namespace}/DELETE_DOCKET_TIME_SLOT`,
);

export const deleteDocketTimeSlot = makeApiActionCreatorV3(
  api.deleteDocketTimeSlot,
  DELETE_DOCKET_TIME_SLOT[START],
  DELETE_DOCKET_TIME_SLOT[SUCCESS],
  DELETE_DOCKET_TIME_SLOT[ERROR],
);

export const FETCH_PROPERTY_DOCKET_GROUPS = createRequestTypes(
  `${namespace}/FETCH_PROPERTY_DOCKET_GROUPS`,
);

export const fetchPropertyDocketGroups = makeApiActionCreatorV3(
  api.fetchPropertyDocketGroups,
  FETCH_PROPERTY_DOCKET_GROUPS[START],
  FETCH_PROPERTY_DOCKET_GROUPS[SUCCESS],
  FETCH_PROPERTY_DOCKET_GROUPS[ERROR],
);

export const INSERT_PROPERTY_DOCKET_GROUP = createRequestTypes(
  `${namespace}/INSERT_PROPERTY_DOCKET_GROUP`,
);

export const insertPropertyDocketGroup = makeApiActionCreatorV3(
  api.insertPropertyDocketGroup,
  INSERT_PROPERTY_DOCKET_GROUP[START],
  INSERT_PROPERTY_DOCKET_GROUP[SUCCESS],
  INSERT_PROPERTY_DOCKET_GROUP[ERROR],
);

export const DELETE_PROPERTY_DOCKET_GROUP = createRequestTypes(
  `${namespace}/DELETE_PROPERTY_DOCKET_GROUP`,
);

export const deletePropertyDocketGroup = makeApiActionCreatorV3(
  api.deletePropertyDocketGroup,
  DELETE_PROPERTY_DOCKET_GROUP[START],
  DELETE_PROPERTY_DOCKET_GROUP[SUCCESS],
  DELETE_PROPERTY_DOCKET_GROUP[ERROR],
);

export const SEARCH_APPEAL_DOCKET_TIMESLOTS = createRequestTypes(
  `${namespace}/SEARCH_APPEAL_DOCKET_TIMESLOTS`,
);

export const searchAppealDocketTimeslots = makeApiActionCreatorV3(
  api.searchAppealDocketTimeslots,
  SEARCH_APPEAL_DOCKET_TIMESLOTS[START],
  SEARCH_APPEAL_DOCKET_TIMESLOTS[SUCCESS],
  SEARCH_APPEAL_DOCKET_TIMESLOTS[ERROR],
);

export const RESET_APPEAL_DOCKET_TIMESLOTS = 'RESET_APPEAL_DOCKET_TIMESLOTS';

export const resetAppealDocketTimeSlots = () => ({
  type: RESET_APPEAL_DOCKET_TIMESLOTS,
});

export const MASS_APPEALS_SCHEDULER = createRequestTypes(
  `${namespace}/MASS_APPEALS_SCHEDULER`,
);

export const massAppealsScheduler = makeApiActionCreatorV3(
  api.massAppealsScheduler,
  MASS_APPEALS_SCHEDULER[START],
  MASS_APPEALS_SCHEDULER[SUCCESS],
  MASS_APPEALS_SCHEDULER[ERROR],
);

export const FETCH_APPEALS_SCHEDULER_STATUS = createRequestTypes(
  `${namespace}/FETCH_APPEALS_SCHEDULER_STATUS`,
);

export const fetchAppealsSchedulerStatus = makeApiActionCreatorV3(
  api.fetchAppealsSchedulerStatus,
  FETCH_APPEALS_SCHEDULER_STATUS[START],
  FETCH_APPEALS_SCHEDULER_STATUS[SUCCESS],
  FETCH_APPEALS_SCHEDULER_STATUS[ERROR],
);

export const FETCH_APPEALS_SCHEDULER_ERRORS = createRequestTypes(
  `${namespace}/FETCH_APPEALS_SCHEDULER_ERRORS`,
);

export const fetchAppealsSchedulerErrors = makeApiActionCreatorV3(
  api.fetchAppealsSchedulerErrors,
  FETCH_APPEALS_SCHEDULER_ERRORS[START],
  FETCH_APPEALS_SCHEDULER_ERRORS[SUCCESS],
  FETCH_APPEALS_SCHEDULER_ERRORS[ERROR],
);

export const CLEAR_AGENT_RESERVATION = createRequestTypes(
  `${namespace}/CLEAR_AGENT_RESERVATION`,
);

export const clearAgentReservation = makeApiActionCreatorV3(
  api.clearAgentReservation,
  CLEAR_AGENT_RESERVATION[START],
  CLEAR_AGENT_RESERVATION[SUCCESS],
  CLEAR_AGENT_RESERVATION[ERROR],
);

export const FETCH_TIME_SLOT_SCHEDULED = createRequestTypes(
  `${namespace}/FETCH_TIME_SLOT_SCHEDULED`,
);

export const fetchTimeSlotScheduled = makeApiActionCreatorV3(
  api.fetchTimeSlotScheduled,
  FETCH_TIME_SLOT_SCHEDULED[START],
  FETCH_TIME_SLOT_SCHEDULED[SUCCESS],
  FETCH_TIME_SLOT_SCHEDULED[ERROR],
);
